import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Table from '../components/Documents/Table';
import Content from '../components/Content';
import { RootState } from '../redux/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import Skeleton from '../components/ui/Skeleton/Skeleton';
import DocumentsFilters from '../components/Documents/Filters';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchDocuments } from '../utils/api';
import { UserInfoType } from '../types/AppTypes';

const currentDate = new Date();

const Documents = (): JSX.Element => {
  const { documents, loading, message, error } = useAppSelector((state) => state.documents);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [startDate, setStartDate] = useState<Date | null>(new Date(new Date().setDate(new Date().getDate() - 7)));
  const timezoneOffset = currentDate.getTimezoneOffset().toString();

  const [skeletonColumns] = useState([
    'Customer ID',
    'Document ID',
    'Version',
    'Duration',
    'Status',
    'Created',
    'Last updated',
    'Username',
    'Actions',
  ]);
  const [skeletonRows] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  const fetchDocumentsByDate = () => {
    let sd =
      sessionStorage.getItem('startDate') !== null && sessionStorage.getItem('startDate') !== ''
        ? sessionStorage.getItem('startDate')
        : startDate;
    let ed =
      sessionStorage.getItem('endDate') !== null && sessionStorage.getItem('endDate') !== ''
        ? sessionStorage.getItem('endDate')
        : endDate;
    if (typeof sd === 'string') {
      sd = new Date(sd);
    }
    if (typeof ed === 'string') {
      ed = new Date(ed);
    }
    if (
      sd?.toString() !== 'Invalid Date' &&
      ed?.toString() !== 'Invalid Date' &&
      sd!.getTime() <= ed!.getTime() &&
      ed!.getTime() >= sd!.getTime()
    ) {
      fetchDocuments(dispatch, timezoneOffset, sd, ed);
    }
  };

  console.log('date', startDate, 'dend', endDate);

  useEffect(() => {
    fetchDocumentsByDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const onChangeEndDate = async (date: Date | null) => {
    setEndDate(date);
    let d = date !== null && date !== undefined ? date : '';
    sessionStorage.setItem('endDate', d.toString());
  };

  const onChangeStartDate = async (date: Date | null) => {
    setStartDate(date);
    let d = date !== null && date !== undefined ? date : '';
    sessionStorage.setItem('startDate', d.toString());
  };

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  const permissions = userInfo?.permissions;

  const disabled =
    startDate?.toString() !== 'Invalid Date' &&
    startDate?.toString !== null &&
    endDate?.toString() !== 'Invalid Date' &&
    endDate?.toString !== null &&
    startDate?.toString !== undefined &&
    endDate?.toString() !== undefined &&
    startDate!.getTime() <= endDate!.getTime() &&
    endDate!.getTime() >= startDate!.getTime()
      ? false
      : true;

  return (
    <>
      {(permissions?.includes('documents.create') || userInfo?.isAdmin) && (
        <p>
          <Link to={'new'}>Create From XML</Link>&nbsp;
          <Link to={'create'}>Create From Text</Link>
        </p>
      )}
      <DocumentsFilters
        startDate={startDate}
        onChangeStartDate={onChangeStartDate}
        endDate={endDate}
        onChangeEndDate={onChangeEndDate}
      />
      <Content loading={false}>
        <Button
          disabled={disabled}
          className="refresh-button"
          variant="primary"
          onClick={() => {
            fetchDocumentsByDate();
          }}
        >
          <FontAwesomeIcon icon={faSyncAlt} />
        </Button>
        {loading ? <Skeleton columns={skeletonColumns} rows={skeletonRows} /> : <Table documents={documents} />}
      </Content>
    </>
  );
};

export default Documents;
